import {createAction} from '@reduxjs/toolkit'
import {ShadowITViews, ShadowITFilter} from 'interfaces'

export const changeShadowITView =
  createAction<ShadowITViews>('changeShadowITView')
export const setShadowITFilter =
  createAction<ShadowITFilter>('setShadowITFilter')
export const resetShadowIT = createAction('resetShadowIT')
export const resetShadowITFilterUpdated = createAction(
  'resetShadowITFilterUpdated',
)
